// Lightweight logger that stays silent in production builds.
const isDev = process.env.NODE_ENV === "development";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};
